var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custSlider"},[_c('hooper',{attrs:{"centerMode":true,"pagination":"no"}},[_vm._l((_vm.imgs),function(img,m){return _c('slide',{key:'image' + m,attrs:{"index":m}},[_c('img',{staticStyle:{"max-height":"170px","max-width":"100%"},attrs:{"src":img},on:{"click":function (){
            if(!_vm.cart.map(function (x){ return x.sku; }).includes(_vm.product.sku)) {
              _vm.addToCart(_vm.product)
            }
          }}})])}),_c('hooper-navigation',{attrs:{"slot":"hooper-addons"},slot:"hooper-addons"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }